import { CommonModule } from "@angular/common";
import { ModuleWithProviders, NgModule, Type } from "@angular/core";
import { PatchBase } from "./patches/patch-base";
import { PATCHES_CONFIG, PatchService } from "./services/patch.service";

@NgModule({
	declarations: [],
	imports: [CommonModule],
	providers: [PatchService]
})
export class PatchModule {
	//#region METHODS

	public static forRoot(paClassPatches: Type<PatchBase>[]): ModuleWithProviders<PatchModule> {
		return {
			ngModule: PatchModule,
			providers: [{ provide: PATCHES_CONFIG, useValue: paClassPatches }]
		};
	}

	//#endregion
}
